import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

export interface Portfolio {
  img: string;
  title: string;
  categories: string[];
  alt: string;
}

@Component({
  standalone: false,
  selector: 'app-portfolio-two-column',
  templateUrl: './portfolio-one.component.html',
  styleUrl: './portfolio-one.component.css'
})
export class PortfolioTwoColumnComponent {
  // Portfolio Filter
  portfolioFilters = ['All', 'Branding', 'App Development', 'Animation', 'Marketing'];
  selectedFilter = 'All';
  
  portfolioItems: Portfolio[] = [
    {
      img: 'assets/images/portfolio/grid/7.jpg',
      title: 'Creative Ideas',
      categories: ['branding', 'animation'],
      alt: 'gallery-1'
    },
    {
      img: 'assets/images/portfolio/grid/8.jpg',
      title: 'Magic Touch',
      categories: ['app-development', 'marketing'],
      alt: 'gallery-2'
    },
    {
      img: 'assets/images/portfolio/grid/9.jpg',
      title: 'Data Analysis',
      categories: ['animation', 'branding'],
      alt: 'gallery-3'
    },
    {
      img: 'assets/images/portfolio/grid/10.jpg',
      title: 'Data Analysis',
      categories: ['marketing', 'branding'],
      alt: 'gallery-4'
    },
    {
      img: 'assets/images/portfolio/grid/11.jpg',
      title: 'Market Research',
      categories: ['app-development', 'branding'],
      alt: 'gallery-5'
    },
    {
      img: 'assets/images/portfolio/grid/12.jpg',
      title: 'Illustration',
      categories: ['app-development', 'marketing'],
      alt: 'gallery-6'
    }
  ];
  // Portfolio Filter End

  // Portfolio Filter Methods
  filterPortfolio(filter: string): void {
    this.selectedFilter = filter;
  }

  isPortfolioVisible(item: Portfolio): boolean {
    if (this.selectedFilter === 'All') {
      return true;
    }
    const selectedFilterLower = this.selectedFilter.toLowerCase().replace(/\s+/g, '-');
    return item.categories.includes(selectedFilterLower);
  }

  formatCategories(categories: string[]): string {
    return categories.join(', ').replace(/-/g, ' ');
  }
  // Portfolio Filter Methods End  
  
  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "brand-1.png"},
    {img: "brand-2.png"},
    {img: "brand-3.png"},
    {img: "brand-4.png"},
    {img: "brand-5.png"},
    {img: "brand-6.png"}
  ];

  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];
}
